import React, { useEffect, useState } from 'react';
import FiltruAcasa from '../components/FiltruAcasa';
import Banner from '../components/Banner';
import { supabase } from '../config/supabaseClient';
import {
  FaMapMarkerAlt, FaStar, FaPhone, FaEnvelope,
  FaVenus, FaMars, FaTimes, FaChevronLeft, FaChevronRight, FaPaw
} from 'react-icons/fa';
import newsImg from '../assests/news.jpg';
import mobileImg from '../assests/imagine.png';
import './Acasa.css';

const Home = () => {
  const [promovate, setPromovate] = useState([]);
  const [anuntDeschis, setAnuntDeschis] = useState(null);
  const [pozaActiva, setPozaActiva] = useState(0);

  useEffect(() => {
    const fetchPromovate = async () => {
      const { data } = await supabase
        .from("anunturi")
        .select("*")
        .eq("promovat", true)
        .eq("activ", true)
        .order("created_at", { ascending: false })
        .limit(6);
      if (data) setPromovate(data);
    };
    fetchPromovate();
  }, []);

  const deschideAnunt = (a) => {
    setAnuntDeschis(a);
    setPozaActiva(0);
    document.body.style.overflow = "hidden";
  };

  const inchideAnunt = () => {
    setAnuntDeschis(null);
    document.body.style.overflow = "auto";
  };

  const pozaPrecedenta = (e) => {
    e.stopPropagation();
    setPozaActiva((prev) =>
      prev === 0 ? anuntDeschis.imagini.length - 1 : prev - 1
    );
  };

  const pozaUrmatoare = (e) => {
    e.stopPropagation();
    setPozaActiva((prev) =>
      prev === anuntDeschis.imagini.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="home-container">
      <main className="main-content">
        <section className="hero-section">
          <div className="hero-image-container">
            <Banner
              desktopImage={newsImg}
              mobileImage={mobileImg}
              alt="Find your pet"
              className="news-banner"
            />
          </div>
        </section>

        <div className="content-wrapper">
          <FiltruAcasa />
        </div>

        {promovate.length > 0 && (
          <section className="promovate-section">
            <div className="promovate-header">
              <FaStar color="#f4b400" size={22} />
              <h2>Anunțuri Promovate</h2>
              <FaStar color="#f4b400" size={22} />
            </div>

            <div className="promovate-grid">
              {promovate.map((a) => (
                <div
                  key={a.id}
                  className="promovat-card"
                  onClick={() => deschideAnunt(a)}
                >
                  <div className="promovat-badge">
                    <FaStar size={12} /> Promovat
                  </div>
                  <div className="promovat-imagine">
                    {a.imagini?.[0] ? (
                      <img src={a.imagini[0]} alt="animal" />
                    ) : (
                      <div className="promovat-no-img">📷</div>
                    )}
                    {a.imagini?.length > 1 && (
                      <span className="promovat-poza-count">
                        📷 {a.imagini.length}
                      </span>
                    )}
                  </div>
                  <div className="promovat-info">
                    <div className="promovat-titlu">
                      <strong>{a.specie === "caine" ? "Caine" : "Pisica"} {a.rasa}</strong>
                      <span className={`tip-badge ${a.tip}`}>
                        {a.tip === "gasit" ? " Găsit" : " Pierdut"}
                      </span>
                    </div>
                    <div className="promovat-detalii">
                      <span><FaMapMarkerAlt /> {a.oras}</span>
                      <span>
                        {a.sex === "mascul"
                          ? <FaMars color="#3b82f6" />
                          : a.sex === "femela"
                          ? <FaVenus color="#ec4899" />
                          : "?"}
                      </span>
                      <span> {a.culoare}</span>
                    </div>
                    <div className="promovat-contact">
                      {a.telefon && (
                        <a href={`tel:${a.telefon}`} onClick={(e) => e.stopPropagation()}>
                          <FaPhone /> {a.telefon}
                        </a>
                      )}
                      {a.email && (
                        <a href={`mailto:${a.email}`} onClick={(e) => e.stopPropagation()}>
                          <FaEnvelope /> {a.email}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* Modal anunț promovat */}
        {anuntDeschis && (
          <div className="modal-overlay" onClick={inchideAnunt}>
            <div className="modal-anunt" onClick={(e) => e.stopPropagation()}>
              <button className="modal-inchide" onClick={inchideAnunt}>
                <FaTimes />
              </button>

              <div className="modal-galerie">
                {anuntDeschis.imagini?.length > 0 ? (
                  <>
                    <img
                      src={anuntDeschis.imagini[pozaActiva]}
                      alt={`poza ${pozaActiva + 1}`}
                      className="modal-poza-principala"
                    />
                    {anuntDeschis.imagini.length > 1 && (
                      <>
                        <button className="btn-poza-nav prev" onClick={pozaPrecedenta}>
                          <FaChevronLeft />
                        </button>
                        <button className="btn-poza-nav next" onClick={pozaUrmatoare}>
                          <FaChevronRight />
                        </button>
                        <div className="modal-thumbnails">
                          {anuntDeschis.imagini.map((src, i) => (
                            <img
                              key={i}
                              src={src}
                              alt={`thumb ${i + 1}`}
                              className={`thumbnail ${i === pozaActiva ? "activ" : ""}`}
                              onClick={(e) => { e.stopPropagation(); setPozaActiva(i); }}
                            />
                          ))}
                        </div>
                        <div className="modal-poza-index">
                          {pozaActiva + 1} / {anuntDeschis.imagini.length}
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <div className="modal-no-image"><FaPaw size={48} color="#ddd" /></div>
                )}
              </div>

              <div className="modal-detalii">
                <div className="modal-titlu">
                  <h2>{anuntDeschis.specie === "caine" ? "Caine" : "Pisica"} {anuntDeschis.rasa}</h2>
                  <span className={`badge-tip ${anuntDeschis.tip}`}>
                    {anuntDeschis.tip === "gasit" ? " Găsit" : " Pierdut"}
                  </span>
                </div>

                <div className="modal-info-grid">
                  <div className="modal-info-item">
                    <span className="label">Specie</span>
                    <span>{anuntDeschis.specie === "caine" ? "Câine" : "Pisică"}</span>
                  </div>
                  <div className="modal-info-item">
                    <span className="label">Rasă</span>
                    <span>{anuntDeschis.rasa || "—"}</span>
                  </div>
                  <div className="modal-info-item">
                    <span className="label">Sex</span>
                    <span>
                      {anuntDeschis.sex === "mascul"
                        ? <><FaMars color="#3b82f6" /> Mascul</>
                        : anuntDeschis.sex === "femela"
                        ? <><FaVenus color="#ec4899" /> Femelă</>
                        : "Necunoscut"}
                    </span>
                  </div>
                  <div className="modal-info-item">
                    <span className="label">Culoare</span>
                    <span>{anuntDeschis.culoare || "—"}</span>
                  </div>
                  <div className="modal-info-item">
                    <span className="label"><FaMapMarkerAlt /> Oraș</span>
                    <span>{anuntDeschis.oras || "—"}</span>
                  </div>
                  <div className="modal-info-item">
                    <span className="label">Data</span>
                    <span>{new Date(anuntDeschis.created_at).toLocaleDateString("ro-RO")}</span>
                  </div>
                </div>

                {anuntDeschis.detalii && (
                  <div className="modal-descriere">
                    <span className="label">Detalii</span>
                    <p>{anuntDeschis.detalii}</p>
                  </div>
                )}

                <div className="modal-contact">
                  <h4>Contact</h4>
                  {anuntDeschis.telefon && (
                    <a href={`tel:${anuntDeschis.telefon}`} className="contact-btn">
                      <FaPhone /> {anuntDeschis.telefon}
                    </a>
                  )}
                  {anuntDeschis.email && (
                    <a href={`mailto:${anuntDeschis.email}`} className="contact-btn">
                      <FaEnvelope /> {anuntDeschis.email}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

      </main>
    </div>
  );
};

export default Home;